// Random display name generator + localStorage persistence.

const ADJECTIVES = [
  "Clever", "Brave", "Calm", "Bright", "Witty", "Lucky", "Merry", "Mighty",
  "Swift", "Bold", "Cosmic", "Sleepy", "Jolly", "Fuzzy", "Quirky", "Glowing"
];
const ANIMALS = [
  "Otter", "Falcon", "Badger", "Fox", "Panda", "Wolf", "Hawk", "Lynx",
  "Owl", "Heron", "Crane", "Stoat", "Marten", "Bison", "Orca", "Tiger"
];

export const STORAGE_KEY = "synthetic-thunder.displayName.v1";

export function generateName(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)] ?? "Clever";
  const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)] ?? "Otter";
  const digits = Math.floor(Math.random() * 9000) + 1000;
  return `${adj}${animal}-${digits}`;
}

export function loadOrCreateName(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored.length > 0 && stored.length <= 32) return stored;
  } catch {
    // ignore
  }
  const fresh = generateName();
  try {
    localStorage.setItem(STORAGE_KEY, fresh);
  } catch {
    // ignore
  }
  return fresh;
}

export function saveName(name: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, name);
  } catch {
    // ignore
  }
}

export function makeId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}